import React from "react";
import {Row, Col, Button, ButtonToolbar, Tab} from "react-bootstrap";
import SshKeyTableRow from "./account-table-sshkey-row"
import FontAwesome from "react-fontawesome";
import UserHandler from "../../utilities/user-handler";
import * as config from "../../config";
import Api from "../../utilities/fnapi-client";
import { Link } from "react-router";
import SftpAccounts from "./account-table-sftp-accounts";

export default React.createClass({

  getInitialState: function() {
    return {
      expanded: false,
      sshKeys: this.props.sshKeys,
      sftpAccounts: this.props.sftpAccounts,
      creatingSshKey: false,
      newSshKeyName: "",
      newSshKeyKey: "",
      sshError: "",
      sshSuccess: "",
      hideHeader: false
    }
  },

  componentDidMount() {
    this.setState({hideHeader: window.innerWidth <= 760});
  },

  handler(sshError, sshSuccess) {
    this.setState({
        sshError: sshError,
        sshSuccess: sshSuccess
    });
  },


  render: function() {
    return (

      <div className="form-table-wrapper">

        <h4>Usage Log SFTP</h4>

        <p>
          SFTP is used for sending usage logs to FaceTec. <Link to="/usage-logs">How to configure usage logs</Link>
        </p>

        {this.state.sftpAccounts.length >= 1 &&
          <SftpAccounts
            sftpAccounts={this.state.sftpAccounts}
          />
        }

        { this.state.sshKeys.length == 0 && this.props.canEdit &&
          <p>To get started please upload a public SSH key.</p>
        }
        { !this.props.canEdit &&
          <p>To create an SFTP account please contact the Administrator of your application.</p>
        }

        <div className="form-table ssh-keys full-width">
          { this.state.sshKeys && this.state.sshKeys.length>0 && !this.state.hideHeader &&
            <div key={this.props.type} className={"form-row form-header " + (this.state.removed ? " removed" : "")}>
              <span className="form-label large">
                SSH Key Name
              </span>
              <span className="form-value large">
                Key Body
              </span>
              <span className="form-icon large">
                Action
              </span>
            </div>
          }
          { this.state.sshKeys &&
            this.state.sshKeys.map(this.renderRow)
          }
          { this.createAddSshKeysUI() }
        </div>

        { this.createAddSshKeysButton() }

        {this.state.sshKeys.length > 0 &&
        <blockquote>
          <p><strong>Upload a test file (Mac terminal, Linux, or Windows Powershell):</strong></p>
          <p>Run <code>echo 'put /path/to/testfile.txt' | sftp YOUR_ASSIGNED_USERNAME@54.70.182.147</code> from the
            machine(s) with the private SSH key corresponding to the public SSH key that you configured.</p>
        </blockquote>
        }



        {this.state.sshError != "" ? <p className="error-message">{this.state.sshError}</p> : "" }
        {this.state.sshSuccess != "" ? <p className="success">{this.state.sshSuccess}</p> : "" }
      </div>

    );
  },

  renderRow: function(item) {
    var key = item.guid;
    return <this.props.row {...item} key={key} canEdit={this.props.canEdit} appToken={this.props.appToken} updateSshKeys={this.props.updateSshKeys}  action={this.handler} />;
  },

  /*********************************************************************************************************************
   SSH Key Helpers
   *********************************************************************************************************************/

  removeAddSshKeysUI: function(){
    this.setState({
      creatingSshKey: false
    });
  },

  clearStateData: function() {
    this.setState({
      newSshKeyName: "",
      newSshKeyKey: "",
      sshError: "",
      sshSuccess: ""
    });
  },

  updateSshKeys: function(sshKeys) {
    this.setState({sshKeys: sshKeys});
  },

  handleSshKeyNameChange(e) {
    this.setState({ newSshKeyName: e.target.value });
  },

  handleSshKeyKeyChange(e) {
    this.setState({ newSshKeyKey: e.target.value });
  },

  createAddSshKeysUI () {

    if(this.state.creatingSshKey) {

      var addIcon;
      if (this.state.sshLoading){
        addIcon = <button className="btn btn-save btn-new"><FontAwesome name="circle-o-notch" className="fa-spin" /></button>;
      }
      else if (this.state.newSshKeyName.length > 3 && this.state.newSshKeyKey.length > 128){
        addIcon = <button className="btn btn-save btn-new" onClick={ this.addSshKeyToApplication }>Save</button>
      }
      else {
        addIcon = <button className="btn btn-save btn-new disabled">Save</button>
      }
      return (
        <div className="form-row add-row">
          <span className="form-value pseudo-label">
            <input type="text" placeholder="Public Key Friendly Name" value={this.state.newSshKeyName} onChange={this.handleSshKeyNameChange } />
          </span>
          <span className="form-value textarea">
            <textarea placeholder="Key" value={this.state.newSshKeyKey} onChange={ this.handleSshKeyKeyChange } />
          </span>
          <span className="form-icon">
            { addIcon }
          </span>
        </div>
      )
    }
  },

  createAddSshKeysButton () {
    if(!this.state.creatingSshKey) {
      return (
        <div>
          { this.props.canEdit &&
          <ButtonToolbar>
            <br />
            <Button onClick={this.handleAddSshKeyUI} className="btn-ssh btn-new">
              Upload New Public SSH Key
            </Button>
          </ButtonToolbar>
          }
        </div>
      );
    }
  },

  handleAddSshKeyUI() {
    this.setState({
      creatingSshKey: true
    });
  },


  addSshKeyToApplication: function(e) {

    this.setState({error:"", success:"", sshLoading: true, sshError: "", sshSuccess:"", userError:"", userSuccess: "" });

    var payload = {
      sshKey: {
        name: this.state.newSshKeyName,
        key: this.state.newSshKeyKey
      }
    };

    var url = "application/" + this.props.appToken + "/update";

    Api.post(url, payload).then((response) => {

      this.setState({
        sshLoading: false,
      });

      if (!response.meta || !response.meta.ok) {
        if (response.meta.ok === false) {
          this.setState({
            creatingSshKey: false,
          });
          this.setState({ sshError: "Error: " + response.meta.message })
        }
        return;
      }

      if (!response || !response.data) {
        this.setState({ sshError: "Sorry, an unknown error has occurred" })
        return;
      }

      this.setState({
        sshKeys: response.data.sshKeys,
        sftpAccounts: response.data.sftpAccounts,
        creatingSshKey: false,
        newSshKeyName: "",
        newSshKeyKey: ""
      });

    }).catch( (error) => {
      this.setState({
        sshLoading: false,
      });
      this.setState({ sshError: "Error: " + error.message })
    });
  },


});



// WEBPACK FOOTER //
// ./src/js/components/account/account-table-sshkey.jsx